import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService, User } from '@app/authentication/services/authentication.service';
import { UsersService } from '@app/users/services/user-service';
import { BaseComponentDirective } from '@core/component/base.component';
import { Bearertoken } from '@shared/authentication/model/bearer-token-model';
import { ImpersonateUser } from '@shared/model/impersonate-user.model';
import { MegaMenuItem, MenuItem } from 'primeng/api';
import { filter, takeUntil } from 'rxjs';
import { DialerState, DialerStateService } from '../services/dialer-service';
import { MenuService } from '../services/menu-service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponentDirective implements OnInit {
    user: Bearertoken;
    // items: MegaMenuItem[];
    items: MegaMenuItem[];
    items1: MenuItem[];
    activeItem: MegaMenuItem;
    profileItems: MenuItem[];
    showDialer = false;
    searchText = '';
    impersonatingUser: string;
    showImpersonate: boolean;
    userObject: User;
    agentid: string;


    constructor(
        private authenticationService: AuthenticationService,
        private readonly menuService: MenuService,
        private router: Router,
        private dialerStateService: DialerStateService,
        private readonly usersService: UsersService,
    ) {
        super();
        this.authenticationService.user.pipe(takeUntil(this.onDestroy$)).subscribe((x) => {
            return (this.user = x);
        });

        this.dialerStateService.showDialerBar.pipe(takeUntil(this.onDestroy$)).subscribe((dialerState: DialerState) => {
            this.showDialer = dialerState.showDialerBar;
        });
    }

    logout() {
        this.authenticationService.logout();
        void this.router.navigate(['login']);
    }

    changePassword() {
        void this.router.navigate(['user-settings/change-password']);
    }
    profile() {
        const userId = this.authenticationService.getLoggedInId();
        const userObject = this.authenticationService.loggedInUser();
        this.userObject = this.authenticationService.loggedInUser();
        this.agentid = this.userObject.Identity['UserName'];

        void this.router.navigate(['/user-settings/profile-settings'], {
            queryParams: { userId, agentid:this.agentid },
        });
    }

    search() {
        if (this.searchText !== '') {
            void this.router.navigate(['/search'], { queryParams: { searchKey: this.searchText } });
            this.searchText = '';
        }
    }

    private updateActiveNav(url: string) {
        const routeMap: Record<string, string> = {
            '/dashboard': 'Dashboard',
            '/leads': 'Leads',
            '/clients': 'Clients',
            '/calendar': 'Calendar',
            '/reports': 'Reports',
            '/users': 'Admin',
            '/user-settings': 'Admin',
            '/lead-status': 'Admin',
        };
        const activeLabel = Object.entries(routeMap).find(([path]) => url.startsWith(path))?.[1];
        for (const item of this.items) {
            item.styleClass = item.label === activeLabel ? 'nav-active' : undefined;
        }
        // PrimeNG megamenu only re-reads styleClass on @Input change —
        // spread into a new array to trigger re-render.
        this.items = [...this.items];
    }

    ngOnInit() {
        super.ngOnInit();
        this.menuService.updateMenus();
        this.menuService.currentMenu.pipe(takeUntil(this.onDestroy$)).subscribe((menus) => {
            this.items = menus;
            this.updateActiveNav(this.router.url);
        });

        this.router.events.pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            takeUntil(this.onDestroy$),
        ).subscribe((e) => {
            this.updateActiveNav(e.urlAfterRedirects || e.url);
        });

        this.profileItems = [
            {
                label: 'My Profile',
                icon: 'pi pi-fw pi-user ',
                styleClass: 'align-menu-items',
                command: () => {
                    this.profile();
                },
            },
            {
                label: 'Change Password',
                icon: 'pi pi-fw pi-cog ',
                styleClass: 'align-menu-items',
                command: () => {
                    this.changePassword();
                },
            },
            {
                label: 'Logout',
                icon: 'pi pi-fw pi-sign-out ',
                styleClass: 'align-menu-items',
                command: () => {
                    this.logout();
                },
            },
        ];

        if (localStorage.hasOwnProperty('userImpersonate')) {
            this.userObject = this.authenticationService.loggedInUser();
            this.showImpersonate = true;
            this.impersonatingUser = this.authenticationService.getLoggedInUserName();

        } else {
            this.showImpersonate = false;
        }
    }

    revertUserImpersonate() {
        const originalToken = localStorage.getItem('originalToken');
        if (originalToken) {
            localStorage.setItem('token', originalToken);
            localStorage.removeItem('originalToken');
            localStorage.removeItem('userImpersonate');
            const parsed = JSON.parse(originalToken);
            this.authenticationService.userSubject.next(parsed);
            this.messageService.add({
                key: 'tst',
                severity: 'success',
                summary: 'Success',
                detail: 'User Impersonate reverted successful',
            });
            void this.router.navigate(['/dashboard'], {
                queryParams: {
                    reload: true,
                },
            });
        } else {
            // Fallback: try API call (for sessions started before this fix)
            const getLastUser = JSON.parse(localStorage.getItem('LastUserImpersonate')) as ImpersonateUser;
            this.usersService
                .userImpersonate(getLastUser.id)
                .pipe(takeUntil(this.onDestroy$))
                .subscribe({
                    next: (user) => {
                        localStorage.setItem('token', JSON.stringify(user));
                        localStorage.removeItem('userImpersonate');
                        this.authenticationService.userSubject.next(user);
                        void this.router.navigate(['/dashboard'], { queryParams: { reload: true } });
                    },
                    error: () => {
                        // API call failed (role not allowed) — force logout
                        this.authenticationService.logout();
                    },
                });
        }
    }
}
